import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoadingMaskService } from '../LoadingMask/LoadingMaskService';

@Injectable({ providedIn: 'root' })
export class WorkfGuard implements CanActivate {

  constructor(private http: HttpClient, private router: Router, private loadingMaskService: LoadingMaskService) {
    
  }

  // PIT40802 \\
  canActivate(): Observable<boolean | UrlTree> {
    //return of(true) ;
    return this.http
      .get<string>('api/Workflow/ValidaDisponibilidadePGPCall', { responseType: 'text' as 'json' })
      .pipe(
        map((res: string) => {

          if (res != null) {
            const result = JSON.parse(res);
            if (result.stateCode == 'I') {
              return this.router.parseUrl('/validatepgponline');
            }
          }

          return true;

        })
      );
  }
}
